import React from 'react'

export default ({width, height}) => (
  <svg className="shape shape--valid" width={width} height={height} viewBox="0 0 288.941 288.941">
    <path id="Check" d="M285.377,46.368c-4.74-4.704-12.439-4.704-17.179,0L96.309,217.114L20.734,142.61
      c-4.74-4.704-12.439-4.704-17.179,0s-4.74,12.319,0,17.011l84.2,82.997c4.692,4.644,12.499,4.644,17.191,0l180.43-179.239
      C290.129,58.687,290.129,51.06,285.377,46.368C280.637,41.664,290.129,51.06,285.377,46.368z"/>
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/Shapes/Valid.js